(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("onlineExamHistory", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/evaluations/onlineExams/onlineExamHistoryView.html",
            controller: ["onlineExamsHistoryResource", "messageService", "$filter", "$scope", "$translate", "$state", "DTOptionsBuilder", "$compile", "$q", OnlineExamHistoryCtrl],
            controllerAs: "vm"
        };
        function OnlineExamHistoryCtrl(onlineExamsHistoryResource, messageService, $filter, $scope, $translate, $state, DTOptionsBuilder, $compile, $q) {
            var vm = this;
            vm.code = $state.params.code;
            vm.person = $state.params.person;
            vm.assignmentId = $state.params.assignmentId;
            vm.isLoading = true;
            onlineExamsHistoryResource.getActivationsDetails({ code: vm.code, person: vm.person }, function (data) {
                vm.pageHeader = data.userFullName + " - " + data.learningItemName + " " + $translate.instant("evaluations.onlineExams.history");
                vm.isLoading = false;
            }, function (error) {
                messageService.error(error);
            });
            vm.lang = $translate.proposedLanguage() || $translate.use();
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
                return $q(function (resolve) {
                    var promise = onlineExamsHistoryResource.query({ assignmentId: vm.assignmentId, person: vm.person }).$promise;
                    promise.then(function (data) {
                        if (data.length === 0) {
                            $state.go("main.evaluations.onlineExamAttemptsHistory", { code: vm.code, person: vm.person, assignmentId: vm.assignmentId, activationNumber: 0 });
                            //reject(); LF - 2024-01-10 this throws an error
                        }
                        else
                            resolve(data);
                    }).catch(angular.noop);
                });
            })
                .withOption("createdRow", function (row) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
            })
                .withOption("headerCallback", function (header) {
                if (!vm.headerCompiled) {
                    // Use this headerCompiled field to only compile header once
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withOption("processing", true)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("stateSave", true)
                .withOption("stateDuration", -1)
                .withPaginationType("full_numbers")
                .withOption("rowCallback", rowCallback)
                .withOption("order", [1, "desc"])
                .withBootstrap();
            vm.dtColumns = [
                {
                    "data": null,
                    "defaultContent": "",
                    "class": "control",
                    "sortable": false,
                    "targets": 0
                },
                {
                    "data": "number",
                    "title": $translate.instant("common.lists.numberSign")
                },
                {
                    "data": "createdDate",
                    "render": function (data) {
                        return data ? moment.utc(data).local().format("MMM DD, Y") : "";
                    },
                    "title": $translate.instant("common.createdDate")
                },
                {
                    "data": "completedDate",
                    "render": function (data) {
                        return data ? moment.utc(data).local().format("MMM DD, Y") : "";
                    },
                    "title": $translate.instant("common.lists.completedDate")
                },
                {
                    "data": null,
                    "render": function (data) {
                        if (data.score)
                            return $filter("sbPercentage")(data.score, 2);
                        return "-";
                    },
                    "title": $translate.instant("common.lists.completedScore"),
                    "class": "text-center"
                },
                {
                    "data": "expiresDate",
                    "render": function (data) {
                        return data ? moment.utc(data).local().format("MMM DD, Y") : "";
                    },
                    "title": $translate.instant("common.lists.expiresDate")
                }
            ];
            function rowCallback(nRow, aData) {
                // Unbind first in order to avoid any duplicate handler
                //(see https://github.com/l-lin/angular-datatables/issues/87)
                $("td:not(.control)", nRow).unbind("click");
                $("td:not(.control)", nRow).bind("click", function () {
                    $scope.$apply(function () {
                        $state.go("main.evaluations.onlineExamAttemptsHistory", { code: vm.code, person: vm.person, assignmentId: vm.assignmentId, activationNumber: aData.number });
                    });
                });
                return nRow;
            }
        }
    });
}());
